import { render, staticRenderFns } from "./form_account_virtual.vue?vue&type=template&id=12abef47&lang=pug&"
import script from "./form_account_virtual.vue?vue&type=script&lang=coffee&"
export * from "./form_account_virtual.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./form_account_virtual.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports